import type { DecisionT } from '../../../data/api.js';
import { analysisReport, decisions, workspace } from '../../../data/state.js';

export interface SummaryLine {
  id: string;
  lineNumber: number;
  description: string;
}

export interface SummaryContext {
  lines: SummaryLine[];
  current: Map<string, DecisionT>;
  decidedCount: number;
  allDecided: boolean;
  base: string;
}

/** Line items, current decisions, and the base currency the summary panes share. */
export function summaryContext(): SummaryContext {
  const ws = workspace.value;
  const lines = ((ws?.lineItems ?? []) as SummaryLine[]).slice().sort((a, b) => a.lineNumber - b.lineNumber);
  const lineIds = new Set(lines.map((line) => line.id));
  const current = new Map(
    decisions.value
      .filter((decision) => lineIds.has(decision.lineItemId))
      .map((decision) => [decision.lineItemId, decision]),
  );
  const decidedCount = current.size;
  const allDecided = lines.length > 0 && decidedCount === lines.length;
  const base = analysisReport.value?.analysis.summary?.base ?? 'PKR';
  return { lines, current, decidedCount, allDecided, base };
}
